var map = {
	"./drop-down.png": "AKR7",
	"./drop-down1.png": "+ejX",
	"./drop.png": "JoY/",
	"./jia.png": "Brru",
	"./jian.png": "bkZa",
	"./lv-down.png": "ZFXs",
	"./lv-up.png": "Ptky",
	"./more-1.png": "/hZb",
	"./more-2.png": "NaU2",
	"./red-down.png": "VJnM",
	"./red-up.png": "3CS2",
	"./rise.png": "2vBh",
	"./trade.png": "UDhK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wLra";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kline ^\.\/.*\.png$
// module id = wLra
// module chunks = 1